import { MDBBtn, MDBCol, MDBRow, MDBTypography, MDBContainer } from 'mdbreact';
import React from 'react';

// Import asset
import "./Ads.scss";
import Services from "./../../../assets/images/icon/services-group.svg";
import Offer from "./../../../assets/images/female/offer.png";
import Employees from "./../../../assets/images/female/Employes.png";
import { Language } from '../../../redux/store/base/language';
import { useSelector } from 'react-redux';

const Ads = (props: AdsProps) => {

    const dictionary = useSelector(
        (state: { lang: Language }) => state.lang.dictionary?.homepage
    );

    return <MDBRow className="ads" center middle>
        <MDBCol sm="12" md="3" className="item">
            <article>
                <MDBRow middle center>
                    <MDBCol className="icon" size="12">
                        <img src={Services} alt="Pic" />
                    </MDBCol>
                </MDBRow>
            </article>
            <p>{dictionary?.a_wide_range_of_services}</p>
        </MDBCol>
        <MDBCol sm="12" md="3" className="item">
            <article>
                <img src={Offer} alt="Pic" />
            </article>
            <p>{dictionary?.the_best_offers_and_discounts}</p>
        </MDBCol>
        <MDBCol sm="12" md="3" className="item">
            <article>
                <MDBRow middle center>
                    <MDBCol className="icon" size="12">
                        <img src={Employees} alt="Pic" />
                    </MDBCol>
                </MDBRow>
            </article>
            <p>{dictionary?.more_than_100_beauty_experts}</p>
        </MDBCol>
    </MDBRow>
};

interface AdsProps { }
export default Ads;